import { gsap } from 'gsap'

export default (target) => {
  var tl = gsap.timeline()
  tl.set(target, { percent: 0, opacity: 1, display: true })
  tl.to(target, { percent: 1, duration: 3, ease: 'slow' })
  tl.to(target, { opacity: 0, duration: 1, ease: 'power2.in', onComplete: () => { target.display = false } }, '-=1')
  return tl
}
